import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {
  BodySmall,
  BodySmallBold,
} from '@spaced-out/ui-design-system/lib/components/Text';
import {TimelineItem} from '@spaced-out/ui-design-system/lib/components/Timeline';
import type {SequentialRound} from '../../../types/IEventTemplate';
import {getDurationLabel} from 'src/components/scheduler/utils';
import type {Duration} from 'src/types/scheduler';
import {generateTestId} from '@spaced-out/ui-design-system/lib/utils/qa';

import css from './sequential-booking-info.css';


interface RoundTimelineItemProps {
  roundNumber: number;
  roundInfo?: SequentialRound;
  index: number;
  testId?: string;
}

export const RoundTimelineItem = ({
  roundNumber,
  roundInfo,
  index,
  testId,
}: RoundTimelineItemProps) => {
  const {t} = useLabelTranslation();

  return (
    <TimelineItem
      testId={generateTestId({
        base: testId,
        slot: 'round-timeline-item',
        index: index.toString(),
      })}
      children={null}
      classNames={{
        icon: css.timelineItemIcon,
      }}
      iconColor="neutral"
      iconType="regular"
      key={`round-${roundNumber}-${index}`}
      iconName={roundNumber.toString()}
      title={
        <BodySmallBold color="secondary">
          {roundInfo?.name || t('Round', 'Round')}
        </BodySmallBold>
      }
      enableCardWrapper={false}
      description={
        <BodySmall color="tertiary">
          {roundInfo?.duration
            ? getDurationLabel(roundInfo.duration as Duration, t)
            : null}
        </BodySmall>
      }
    />
  );
};
